<div class="wrapper">
    <fieldset class="fieldset" [disabled]="disabled" [ngClass]="{
      enabled: !disabled,
      disabled: disabled
    }">
        <div class="dropzone" fileDrop [allowedExtensions]="this.fileFormats!" [allowMultipleFiles]="true" (invalidFileEmitter)="invalidFiles($event)" (filesChangeEmitter)="onFileChange($event)">
            <input type="file" name="file" id="file" [accept]="fileFormats.concat(',')" (click)="resetChangeDetection()" (change)="onFileChange($event.target)" [multiple]="fileLimit !== 1" />
            <label for="file">
        <div class="subheader">
          <span>{{'DragAndDrop' | translate }} <b class="textLink pointer">{{'Browse' | translate }}</b></span>
          <span>{{ supportText }}</span>
        </div>
      </label>
        </div>
    </fieldset>
    <table>
        <tbody>
            @for (file of this.fileList; track file) { @if (file.displayName) {
            <tr [ngClass]="{failed: file.status === 'failed'}">
                <td>{{ file.displayName }}</td>
                <td>
                    <div class="status">
                        <!-- Show error state: Display when file.status === 'failed' -->
                        <ng-container *ngIf="file.status === 'failed'">
                            <span>failed</span>
                            <mat-icon class="error-icon" [matTooltip]="processingFailedTooltip">error_outline</mat-icon>
                        </ng-container>
                        <!-- Show success state: Display when file.status === 'processed' OR file.status === 'uploaded' OR file.status === 'appended' -->
                        <ng-container *ngIf="file.status === 'processed' || file.status === 'uploaded' || file.status === 'appended'">
                            <div class="flex-box">
                                <mat-icon class="done-icon">done</mat-icon>
                            </div>
                            <div class="flex-box"></div>
                        </ng-container>
                        <!-- Show uploading state: Display when file.status === 'queued' OR file.status === 'running' -->
                        <ng-container *ngIf="file.status === 'queued' || file.status === 'running'">
                            <span class="processing">uploading...</span>
                            <mat-spinner [diameter]="25"></mat-spinner>
                        </ng-container>
                        <!-- Show cancelled state: Display when file.status === 'cancelled' -->
                        <ng-container *ngIf="file.status === 'cancelled'">
                            <div class="flex-box">
                                <mat-icon class="cancelled-icon">cancel</mat-icon>
                                <span>cancelled</span>
                            </div>
                        </ng-container>
                        <!-- Handle undefined or unknown file statuses (fallback for any status not explicitly handled above) -->
                        <ng-container *ngIf="file.status !== 'failed' && file.status !== 'processed' && file.status !== 'uploaded' && file.status !== 'appended' && file.status !== 'queued' && file.status !== 'running' && file.status !== 'cancelled'">
                            <div class="flex-box">
                                <mat-icon class="warning-icon">warning</mat-icon>
                                <span>{{ file.status || 'undefined status' }}</span>
                            </div>
                        </ng-container>
                    </div>
                </td>
                <td>
                    <!-- Disable delete action when disabled === true OR file.status is not in a deletable state OR isStatusNotAwaitInput === true -->
                    <fieldset class="fieldset" [ngClass]="{'fieldset-disabled': disabled || !['processed', 'uploaded', 'appended', 'failed', 'cancelled'].includes(file.status) || isStatusNotAwaitInput }">
                        <div class="flex-box">
                            <!-- Apply 'pointer' class when file.status is clickable (completed states)
                   Apply 'disabled-icon' class when file.status is processing or unknown -->
                            <mat-icon [ngClass]="{
                pointer: ['processed', 'uploaded', 'appended', 'completed', 'failed', 'cancelled'].includes(file.status),
                'disabled-icon': !['processed', 'uploaded', 'appended', 'completed', 'failed', 'cancelled'].includes(file.status)
              }" (click)="deleteFile(file)">delete</mat-icon>
                        </div>
                    </fieldset>
                </td>
            </tr>
            } }
            <!-- TMP FILES -->
            @for (file of this.tempFiles; track file) { @if (file.displayName) {
            <tr>
                <td>{{ file.displayName }}</td>
                <td>
                    <div class="status">
                        <span>{{'Upload' | translate }}...</span>
                    </div>
                </td>
                <td>
                </td>
            </tr>
            } }
        </tbody>
    </table>
</div>